import request from "@/utils/request.js"

// 驿站-新增(跨租户)
export const addStoreIgnore = (formData) => {
    return request.post(`/store/ignoreTenant`, formData)
}

// 门店-详情(跨租户)
export const getStoreIgnore = (id) => {
    return request.get(`/store/ignoreTenant/${id}`)
}

// 驿站-修改(跨租户)
export const updateStoreIgnore = (updateData) => {
    return request.put(`/store/ignoreTenant`, updateData)
}
